/**
 * Anonymous usage counts via Umami Cloud (cookieless). The tracker is loaded in
 * index.html with data-exclude-hash and data-exclude-search, so the plan stored
 * in the URL fragment is never sent.
 *
 * Rule for every call site: send the NAME of an action and, at most, which
 * control it was. Never send an amount, an age, a city or any other input.
 */

export type AnalyticsEvent =
  | "results-shown"
  | "tab-opened"
  | "link-copied"
  | "spending-applied"
  | "allocation-chosen"
  | "info-opened"
  | "summary-printed"
  | "feedback-vote"
  | "feedback-email";

type Umami = { track: (name: string, data?: Record<string, string>) => void };

export function track(name: AnalyticsEvent, data?: Record<string, string>): void {
  try {
    const umami = (window as unknown as { umami?: Umami }).umami;
    umami?.track(name, data);
  } catch {
    // Blocked or not loaded (ad blocker, localhost, offline): the app works the same.
  }
}
